import { getFunctions, httpsCallable } from 'firebase/functions';

export interface Headline {
  title: string;
  link: string;
  source: string;
  category: string;
  image: string | null;
  publishedAt: string | null;
}

// Labels are what the tabs show; the values match the `category` the
// newsHeadlines function returns. `all` is the unfiltered view.
export const NEWS_CATEGORIES = [
  { value: 'all', label: 'All' },
  { value: 'news', label: 'Headlines' },
  { value: 'irish', label: 'Irish' },
  { value: 'sport', label: 'Sport' },
  { value: 'gaming', label: 'Gaming' },
  { value: 'tech', label: 'Tech' },
] as const;

export const fetchHeadlines = async () => {
  const call = httpsCallable<void, { items: Headline[] }>(
    getFunctions(),
    'newsHeadlines'
  );
  const { data } = await call();
  return data.items;
};

export const relativeTime = (iso: string | null) => {
  if (!iso) return null;

  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;

  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours}h ago`;

  const days = Math.round(hours / 24);
  return days === 1 ? 'yesterday' : `${days}d ago`;
};
